import { SetStateAction, Dispatch, useState, useCallback } from 'react';

export const useResettableState = <T>(initialState: T): [T, Dispatch<SetStateAction<T>>, () => void] => {
  const [state, setState] = useState<T>(initialState);
  const resetState = useCallback((): void => setState(initialState), [initialState]);
  return [state, setState, resetState];
};
